import { useState } from "react";
import { unwrapPayload } from "../../utilities";
import { Alert, Button, FormGroup, Input, Label } from "reactstrap";

export function WorkerActionsSection
(
    {
        preparePending,
        sendPrepared
    }
    :
    {
        preparePending: (values: any) => Promise<any>;
        sendPrepared: (values: any) => Promise<any>;
    }
)
{
    const [limit, setLimit] = useState(25);
    const [respectSynchronizationPause, setRespectSynchronizationPause] = useState(true);
    const [result, setResult] = useState<any | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [isRunning, setIsRunning] = useState(false);

    const run = async (action: (values: any) => Promise<any>) =>
    {
        setError(null);
        setResult(null);
        setIsRunning(true);

        try
        {
            const response = await action({
                limit,
                respectSynchronizationPause
            });

            setResult(unwrapPayload(response));
        }
        catch (exception: any)
        {
            setError(exception?.message ?? 'Akcja zakończyła się błędem.');
        }
        finally
        {
            setIsRunning(false);
        }
    };

    return (
        <section className="mt-5">
            <h5>Ręczne wykonanie etapów eksportu</h5>
            <p className="text-muted">
                Narzędzia serwisowe do ręcznego wykonania etapów, które normalnie obsługuje automatyczny worker.
            </p>

            {error && <Alert color="danger">{error}</Alert>}

            <div className="row">
                <div className="col-12 col-xl-3">
                    <FormGroup>
                        <Label>Limit</Label>
                        <Input
                            type="number"
                            min={1}
                            max={250}
                            value={limit}
                            onChange={event => setLimit(Number.parseInt(event.target.value, 10) || 25)}
                        />
                    </FormGroup>
                </div>

                <div className="col-12 col-xl-5">
                    <FormGroup check className="mt-xl-4">
                        <Label check>
                            <Input
                                type="checkbox"
                                checked={respectSynchronizationPause}
                                onChange={event => setRespectSynchronizationPause(event.target.checked)}
                            />
                            Uwzględnij pauzę i wyłączenie integracji
                        </Label>
                    </FormGroup>
                </div>

                <div className="col-12 col-xl-4 d-flex align-items-end justify-content-xl-end">
                    <Button
                        type="button"
                        color="secondary"
                        className="mr-2 mb-3"
                        disabled={isRunning}
                        onClick={() => run(preparePending)}
                    >
                        Przygotuj oczekujące
                    </Button>

                    <Button
                        type="button"
                        color="warning"
                        className="mb-3"
                        disabled={isRunning}
                        onClick={() => run(sendPrepared)}
                    >
                        Wyślij przygotowane
                    </Button>
                </div>
            </div>

            {result && (
                <details className="mt-3" open>
                    <summary>Wynik</summary>
                    <pre className="mt-3">{JSON.stringify(result, null, 2)}</pre>
                </details>
            )}
        </section>
    );
}